'use client';
import { OverlayMinimalHeroProps } from '@/components/hero/types';
import { Link } from '@/components/link/Link';
import { BaseImage } from '@/components/baseImage/BaseImage';
import { Headline } from '@/components/headline/Headline';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';

export default function OverlayMinimalHero({
  headline,
  description,
  link,
  image,
  spacingBottom,
  spacingTop,
  sectionId,
}: OverlayMinimalHeroProps) {
  return (
    <div
      id={sectionId}
      className={`overlay-minimal-heo relative aspect-[1/1] w-full lg:aspect-[9/4] ${
        spacingTop ? 'pt-4 md:pt-8 lg:pt-20' : ''
      } ${spacingBottom ? 'pb-4 md:pb-8 lg:pb-20' : ''}`}
    >
      {image && (
        <>
          <BaseImage
            {...image}
            classNameImage="absolute inset-0 w-full h-full object-cover z-0"
            prerender={true}
            sizes="100vw"
          />
          <div
            className="z-1 absolute inset-0 bg-neutral-700 bg-opacity-70"
            role="presentation"
          ></div>
        </>
      )}

      {/* Content wrapper positioned absolutely at the bottom */}
      <div className="absolute bottom-0 left-0 z-10 w-full px-4 sm:px-0">
        <div className="container mx-auto grid grid-cols-4 gap-4 sm:grid-cols-8 md:grid-cols-8 lg:grid-cols-12 xl:grid-cols-12">
          <div className="content__wrapper col-span-4 sm:col-span-6 md:col-span-6 md:py-12 lg:col-start-1 lg:col-end-7 xl:col-end-7">
            <Headline
              {...headline}
              className="mb-6 text-4xl font-bold text-white md:text-5xl"
            >
              {headline.title}
            </Headline>
            {description && (
              <div className="hero-overlay-content mb-6 text-base text-white sm:text-lg lg:text-xl">
                <SerializeDescription description={description} />
              </div>
            )}
            {link && (
              <div className="split-image-hero__link w-fit lg:mb-4">
                {link && <Link {...link} className="px-0" />}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
